export default __webpack_public_path__ + "static/media/brand-9.3795b24f.png";